import React from 'react';
import Box from '@material-ui/core/Box';
import ListSubheader from '@material-ui/core/ListSubheader';
import LoaderContent from 'UI/components/templates/DrawerContentLayout/LoaderContent';

import { ConversationListItem } from '../ConversationListItem';

import { SearchResultsContainer } from './SearchResults.styled';

export const SearchResults = ({
  results,
  isLoading,
  customMessageKey,
  selectedConversationId,
  onClickConversation
}) => {
  if (isLoading) {
    return (
      <SearchResultsContainer>
        <LoaderContent color="primary" />
      </SearchResultsContainer>
    );
  }

  const getConversationItem = conversation => {
    return (
      <ConversationListItem
        key={conversation[customMessageKey] || conversation.id}
        conversation={conversation}
        isSelected={
          selectedConversationId === conversation[customMessageKey] ||
          selectedConversationId === conversation.id
        }
        onClickConversation={onClickConversation}
      />
    );
  };

  return (
    <SearchResultsContainer>
      <li>
        <ul>
          <ListSubheader>Contacts ({results.contacts.length})</ListSubheader>
          <Box>{results.contacts.map(getConversationItem)}</Box>
        </ul>
      </li>
      <li>
        <ul>
          <ListSubheader>Messages ({results.conversations.length})</ListSubheader>
          <Box>{results.conversations.map(getConversationItem)}</Box>
        </ul>
      </li>
    </SearchResultsContainer>
  );
};
